module.exports = __webpack_public_path__ + "components/page-header/static/weather-badge-4a2b5d69fcdf607c3f09d85d91b6abad.svg";